import { render } from "./TipoTerceros.vue?vue&type=template&id=1d566ef5"
import script from "./TipoTerceros.vue?vue&type=script&lang=js"
export * from "./TipoTerceros.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__